module.exports = __webpack_public_path__ + "static/media/safetypay.8c981ff6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-order/payment-method/safetypay.png
// module id = 1674
// module chunks = 0